import classNames from 'classnames/bind';
import React from 'react';

import MapView from './01_MapView';
import PhotosOverlay from './02_PhotosOverlay';
import styles from './index.module.scss';

import SettingsModal from '@/components/modals/Settings';
import { ModalService as modal } from '@/libs/Modal';

const cx = classNames.bind(styles);

const Options = ({ robot }) => {
  const openSettings = () => {
    modal.show(SettingsModal, { robot });
  };

  return (
    <div className={cx('container')}>
      <MapView robotId={robot.id} />
      <PhotosOverlay robotId={robot.id} />
      {robot.isOwned && robot.model.agentType === 'MavLink' && (
        <button type="button" className={cx('button')} onClick={openSettings}>
          Open Settings
        </button>
      )}
    </div>
  );
};

export default Options;
